import { getShellLogger } from '../common/logger'
import { auth, isAuthenticationRequired, loginOnce } from '../services/auth'
import { removeToken } from '../services/auth/token'
import { HTTP401 } from '../services/errors'
import { getUserInfo } from '../services/identity'
import type { UserInfo } from '../services/identity/models'

export const fetchUserInfoFromInternalAPIs = async (): Promise<UserInfo | undefined> => {
  const hasToken = await auth()

  if (!hasToken) {
    return {} as UserInfo
  }

  try {
    const userInfo = await getUserInfo()

    return userInfo
  } catch (error) {
    getShellLogger().error(error)

    if (error instanceof HTTP401 && (await isAuthenticationRequired())) {
      removeToken()
      await loginOnce()
    }
  }
}
